
import WebhookCardDialog from '@/components/Domain.Webhooks/WebhookCardDialog.vue';
import EditWebhookButton from '@/components/Domain.Webhooks/EditWebhookButton.vue';
import { toastSuccess } from '@/components/Common/Toast.vue';
export default {
    components: { WebhookCardDialog, EditWebhookButton },
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        webhook: {
            type: Object,
            default: null,
        },
    },
    methods: {
        handleSuccessfulCreation(form) {
            toastSuccess(this.$t('editWebhookDialog.events.successfulUpdates', { webhookName: form.name }));
            this.$emit('http2xx', form);
            this.$emit('editComplete');
        },
    },
};
